export default {"src":"/_next/static/media/RCI.546bd55f.svg","height":18,"width":18};